<template>
    <div ref="tools" id="tools" class="border border-solid border-grey-light rounded overflow-hidden ps-container email-scroll-area ps ps--theme_default">
        <!-- Tela inicial do relatório de chats de suporte -->
        <div class="p-6">
            <h1 class="text-2xl font-bold mb-4 text-center">Chats de suporte</h1>
        </div>

        <div class="p-6">
            <!-- Botão que ao clicar abre o componente BIChatsSuporte no logar desse -->
            <router-link :to="'help-queries/support-chats-report'">
                <vs-button
                    class="align-center mx-auto block"
                    color="primary"
                >
                    Acessar relatório de chats de suporte
                </vs-button>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "tools",
        data() {
            return {
                
            }
        },
        computed: {
        },
        methods: {
            async execQuery(query, select, log) {
                this.$vs.loading({scale: 0.6});
                const servidor = this.selectedServer;
                const banco = this.selectedDB;
                const conexao = this.conexao;
                try {
                    const {
                        data: {data, time}
                    } = await this.$axios.post(`tools/exec/${servidor}/${banco}`, {
                        query,
                        conexao,
                        select,
                        log
                    });

                    if (this.selectPaginate && this.selectPaginate.offset > 0) {
                        if (data.length > 0) {
                            this.results = this.results.concat(data);
                        }
                    } else {
                        this.columns = (data.length > 0) ? Object.keys(data[0]) : [];
                        this.results = data;
                    }
                    if (log) {
                        this.minhasQueries.unshift({
                            comando: query.replace(/LIMIT\s\d+\sOFFSET\s\d$/igm, "")
                        })
                    }
                    this.$vs.notify({
                        text: `Comando executado em ${time.toFixed(4)} ms`,
                        color: "#222222",
                        position: 'top-right'
                    });

                } catch ({message}) {
                    this.$vs.notify({
                        title: 'Erro',
                        text: message,
                        color: "rgb(242, 19, 93)",
                        time: 10000,
                        position: 'top-right'
                    });
                }
                this.$vs.loading.close();
            },




        },
        mounted() {
        },
        beforeDestroy: function () {
        },
        components: {
        },
        watch: {
            query(val) {
                this.code = val;
            },
            code() {
                this.setMaxHeight();
            },
            selectedServer() {
                this.getQueries();
            },
            selectedDB() {
                this.getQueries();
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/apps/email.scss";
</style>

<style>
    #tools {
        height: 100%;

        background-color: #fff;
    }
</style>
